import { Scalars } from "../graphql/__generated__/graphql";

type CartLines = {
  id: Scalars["ID"];
  properties?: object;
  quantity: number;
  selling_plan?: Scalars["ID"];
};

type ChangeItemInput = {
  id: Scalars["ID"];
  properties?: object;
  selling_plan?: number;
  quantity?: number;
};

type UpdateInput = {
  [itemKey: string]: number;
};

export const ajaxCartAdd = async (cartItems: CartLines[]) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: cartItems,
      }),
    });

    return response.json();
  } catch (error) {
    console.error(error);
  }
};

export const ajaxCartChange = async (item: ChangeItemInput) => {
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(item),
    });

    return response.json();
  } catch (error) {
    console.error(error);
  }
};

export const ajaxCartUpdate = async (updates: UpdateInput) => {
  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates,
      }),
    });

    return response.json();
  } catch (error) {
    console.error(error);
  }
};
